import React, { useEffect, useState } from 'react';

interface AnimatedModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

const AnimatedModal: React.FC<AnimatedModalProps> = ({ isOpen, onClose, children }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setIsVisible(true);
      setTimeout(() => setIsAnimating(true), 10);
    } else {
      setIsAnimating(false);
      setTimeout(() => setIsVisible(false), 200);
    }
  }, [isOpen]);

  const handleClose = () => {
    onClose();
  };

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  if (!isVisible) return null;

  return (
    <div 
      onClick={handleOverlayClick}
      style={{
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: `rgba(0, 0, 0, ${isAnimating ? '0.5' : '0'})`,
        display: 'flex', justifyContent: 'center', alignItems: 'center',
        zIndex: 9999,
        transition: 'background-color 0.2s ease-in-out'
      }}
    >
      <div style={{
        transform: `scale(${isAnimating ? '1' : '0.9'}) translateY(${isAnimating ? '0' : '20px'})`,
        opacity: isAnimating ? 1 : 0,
        transition: 'all 0.2s ease-in-out'
      }}>
        {children}
      </div>
    </div>
  );
};

export default AnimatedModal;